import KeepAlive from 'react-activation'
import { useLocation } from 'react-router-dom'
import {SActionBtn, SBack, SLowcodeList, STableActions} from 'shj-components'
import { config } from './config'
import { useRef, useState } from 'react'
import { getBranchComponyList } from '@/services/homeService'
import { isArray } from 'lodash-es'
import dayjs from 'dayjs'
import { asyncImportExportTaskDownloadExcel, staffSatisfactionReport } from '@/services/evaluateConfig.ts'
import {getAllCompanyMrn} from "@/services/customerServices.ts";
import { message } from 'antd'
import { fileConfirm } from '@/utils/file.ts'
import AddOrEditDom from "./components/AddOrEdit";

const EmployeeSatisfactionSurvey = () => {
  const listRef = useRef<any>();
  const [exportLoading, setExportLoading] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>({});

  const startTime = dayjs(new Date()).startOf('month').format('YYYY-MM-DD HH:mm:ss')
  const endTime = dayjs(new Date()).endOf('month').format('YYYY-MM-DD HH:mm:ss')

  const filterSearch = (data: any, field: string, s: string, e: string) => {
    if (data[field] && isArray(data[field])) {
      data[s] = dayjs(data[field][0]).format('YYYY-MM-DD HH:mm:ss')
      data[e] = dayjs(data[field][1]).format('YYYY-MM-DD HH:mm:ss')
      delete data[field]
    }
    return data
  }
  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { query } = values
        const dataQuery = { ...filterSearch(query, 'date', 'startDate', 'endDate') }
        staffSatisfactionReport(dataQuery).then(data => {
          resolve(data)
        }).catch(() => {
          reject({ success: false })
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  const getStatusOptions = () => {
    return new Promise(resolve => {
      Promise.all([getBranchComponyList()]).then((res: any) => {
        const obj = {
          companyList: res[0],
        }
        resolve({ ...obj })
      })
    })
  }

  // 参数处理
  const handleParams = (values: any) => {
    const obj = { ...filterSearch(values, 'date', 'startDate', 'endDate') };
    // 固定参数
    return {
      taskName: '问卷满意度员工维度报表',
      reqParam: JSON.stringify(obj),
      taskCode: 'StaffSatisfactionReportExcel',
      taskSource: 'MEMBER',
      taskRemark: '问卷满意度员工维度报表导出',
    };
  };

  // 导出
  const onExport = async () => {
    const searchData_ = listRef?.current?.getSearch()?.getFieldsValue();
    const values = handleParams(searchData_);
    if (exportLoading) return;
    setExportLoading(true);
    console.log(values);
    message.loading({ content: '导出中' });
    asyncImportExportTaskDownloadExcel(values)
      .then(() => {
        message.destroy();
        fileConfirm();
      })
      .catch(() => {
        message.destroy();
      }).finally(() => {
      setExportLoading(false)
    })
  };

  const onCompanyChange = async (value: any) => {
    listRef?.current?.updateSearchData('ucenterId', "");
    listRef?.current?.updateSearchData('staffList', [])
    getAllCompanyMrn({userIdentityFilter: {companyId: value}}).then(res => {
      console.log(111,res)
      const list = isArray(res)?res:[];
      listRef?.current?.updateSearchData('staffList', list)
    })
  };

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onExport,onCompanyChange },
    status: { exportLoading },
    searchFormConfig: {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    },
    customRender: {
      operationFn(_text: any, record: any) {
        return (
            <STableActions>
              <SActionBtn
                  onClick={() => {
                    setIsVisible(true);
                    setCurrentRecord(record);
                  }}
              >
                查看问题详情
              </SActionBtn>
            </STableActions>
        );
      },
    },
  }
  return (
    <>
      <SBack title={`满意度问卷-员工维度2`}></SBack>
      <SLowcodeList
        config={{
          ...config,
          searchInitialValues: {
            date: [dayjs(startTime), dayjs(endTime)],
          },
          pagination: false,
        }}
        scroll={{ y: 'calc(100vh - 260px)' }}
        ref={listRef}
        {...extension}
        searchMode="group"
      />
      {isVisible ? (
          <AddOrEditDom
              open={isVisible}
              record={currentRecord}
              onClose={() => {
                setIsVisible(false);
                setCurrentRecord({});
              }}
              reload={listRef.current?.reload}
          />
      ) : null}
    </>
  )
}

export default (props: any) => {
  const location = useLocation()
  return (
      <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
        <EmployeeSatisfactionSurvey {...props} />
      </KeepAlive>
  )
}
